module.exports = __webpack_public_path__ + "static/media/benefits-ic-02.fcaf9eac.svg";